import CS from "@assets/icons/flags/cz.webp";
import EN from "@assets/icons/flags/en.webp";
import { Column, Row } from "@components/Layout";
import type { TTSBlock } from "@components/TTSEditor/types";
import { Template } from "@components/Template";
import { Image } from "@kobalte/core";
import { type Setter, type VoidComponent, createMemo, createUniqueId } from "solid-js";
import type { SetStoreFunction } from "solid-js/store";
import ModeButton from "./components/ModeButton";
import { FlagIcon } from "./styled";
import type { TTSGender, TTSLanguage } from "./types";
import { getVoice } from "./utils";

const ModeSelect: VoidComponent<{
	setTTSBlocks: SetStoreFunction<TTSBlock[]>;
	onPick: (advanced?: boolean) => void;
	language: TTSLanguage;
	setLanguage: Setter<TTSLanguage>;
}> = (props) => {
	const handlePick = (gender: TTSGender, advanced?: boolean) => {
		if (gender === "both") {
			const genders: Exclude<TTSGender, "both">[] = ["female", "male", "female", "male"];
			const blocks = genders.map<TTSBlock>((g) => {
				const voice = getVoice(props.language, g);
				return {
					languageCode: voice.languageCode,
					text: "",
					voice: voice.code,
					id: createUniqueId(),
				};
			});
			props.setTTSBlocks(blocks);
		} else {
			const voice = getVoice(props.language, gender);

			const block: TTSBlock = {
				languageCode: voice.languageCode,
				text: "",
				voice: voice.code,
				id: createUniqueId(),
			};
			props.setTTSBlocks([block]);
		}
		props.onPick(advanced);
	};
	const femaleVoice = createMemo(() => getVoice(props.language, "female"));
	const maleVoice = createMemo(() => getVoice(props.language, "male"));

	return (
		<Column gap="10px">
			<Row gap="10px">
				<FlagIcon selected={props.language === "cs"} onclick={() => props.setLanguage("cs")}>
					<Image.Img src={CS} />
					<Image.Fallback>
						<Template w="100%" h="100%" />
					</Image.Fallback>
				</FlagIcon>
				<FlagIcon selected={props.language === "en"} onclick={() => props.setLanguage("en")}>
					<Image.Img src={EN} />
					<Image.Fallback>
						<Template w="100%" h="100%" />
					</Image.Fallback>
				</FlagIcon>
			</Row>
			<Row flexWrap="wrap" gap="20px" justifyContent="center" padding="20px 0">
				<ModeButton
					name={femaleVoice().name}
					photo={femaleVoice().photo}
					source={femaleVoice().sample}
					voice_code={femaleVoice().code}
					onClick={() => handlePick("female")}
				/>
				<ModeButton
					name={maleVoice().name}
					photo={maleVoice().photo}
					source={maleVoice().sample}
					voice_code={maleVoice().code}
					onClick={() => handlePick("male")}
				/>
				<ModeButton
					name="dialog"
					photo={`/faces/both/${props.language}-both.webp`}
					source={`/voice_samples/${props.language}-both.mp3`}
					voice_code={`${props.language}-both`}
					onClick={() => handlePick("both", true)}
				/>
			</Row>
		</Column>
	);
};
export default ModeSelect;
